import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import __ from "lodash";

const formatChars={
  "U": "[A-Z]",
  "X": "[A-Za-z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const MaskedText = props => {
  const [state, setState] = useState({
    value: props.value,
  });

  function sentenceCase (str) {
    if ((str===null) || (str===''))
      return false;
    else
      str = str.toString();

    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1);});
  }

  const handleChangeComplete = event => {
    let newValue = props.forceUpperCase ? event.target.value.toUpperCase() : event.target.value;
    if (props.forceSentenceCase) {
      newValue = sentenceCase (newValue);
    }

    setState({...state, value: newValue});
    props.onChange(newValue);
  };

  if (!props.value && props.defaultValue) {
    props.onChange(props.defaultValue);
  }

  let labelProps = {...props.inputLabelProps};
  if (props.label && (!__.isEmpty(props.value) || !__.has(props?.inputLabelProps, ["shrink"]))) {
    labelProps = {shrink: !__.isEmpty(props.value)}
  }
  let inputProps = {...props.inputProps};
  let classNames = Array.isArray(props.className)?[...props.className]:[props.className]
  if (props.readOnly) {
    inputProps.readOnly = true;
    if (Array.isArray(inputProps.className)){
      inputProps.className = [...inputProps.className, 'readOnly'].join(' ');
    } else {
      inputProps.className = [inputProps.className, 'readOnly'].join(' ');
    }
    classNames.push('readonly');
  }
  const className = classNames.join(' ');
  return (
    <InputMask value={props.value}
               error={props.error}
               helperText={props.helperText}
               mask={props.mask}
               permanents={props.permanents || []}
               beforeMaskedValueChange={props.beforeMaskedValueChange}
               alwaysShowMask={props.alwaysShowMask || false}
               maskChar={props.maskChar || '' }
               formatChars={props.formatChars || formatChars}
               defaultValue={props.defaultValue}
               onChange={handleChangeComplete}
    >
      {() => <TextField
              error={props.error}
              helperText={props.helperText}
              className={className}
              variant={props.variant || 'standard'}
              label={props.label || ""}
              required={props.required || false}
              inputProps={inputProps}
              InputProps={inputProps}
              InputLabelProps={labelProps}
              id={props.id}
              style={props.style}
              fullWidth={props.fullWidth}
              type={props.type}
             />}
    </InputMask>
  )
};

export default MaskedText;
export {formatChars};
